import React, { Component } from 'react';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import Alert from 'components/ui/Alert';
import CargomaticCard from 'components/v2/card';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import VALIDATION_STATES from 'constants/ValidationStates';
import SessionStore from 'stores/SessionStore';
import BillingStore from 'stores/shipper/BillingStore';
import ToastStore from 'stores/ToastStore';
const months = BillingStore.getExpireMonthAvaliableValues().map((m) => ({
    name: m,
    value: m,
}));
function getStripeCustomerId() {
    const user = SessionStore.getUser();
    if (user.stripe_customer_id) {
        return user.stripe_customer_id;
    }
    return 'No Stripe ID (No Card Registered)';
}
class CreditCardForm extends Component {
    static isCardExist() {
        return !!SessionStore.getUser().stripe_customer_id;
    }
    static getExpiryMonthFromInt(expMonth) {
        if (expMonth < 10) {
            return `0${expMonth}`;
        }
        return expMonth.toString();
    }
    constructor(props) {
        super(props);
        this.onSave = () => {
            ToastStore.removeLatestNotification();
            const { cardNumber, cvv, expiryMonth, expiryYear } = this.state;
            const data = {
                cvv,
                cardNumber,
                expiryMonth,
                expiryYear,
                userId: SessionStore.getUser()._id,
            };
            CustomersActionCreators.validateAndUpdateCreditCard(data);
        };
        this.handleInputChange = (field) => (value) => {
            this.setState({
                [field]: value,
            });
        };
        this.handleMonthChange = (item) => {
            this.setState({ expiryMonth: item.value });
        };
        this.refresh = () => {
            this.updateValidation();
            this.updateCreditCard();
        };
        this.state = {
            cardNumber: '',
            expiryMonth: BillingStore.getExpireMonthAvaliableValues()[0],
            expiryYear: BillingStore.getStartExpireYear(),
            cvv: '',
            validations: {},
            loading: CreditCardForm.isCardExist(),
        };
    }
    componentDidMount() {
        BillingStore.addChangeListener(this.refresh);
        if (CreditCardForm.isCardExist()) {
            CustomersActionCreators.getCreditCards(SessionStore.getUser()._id);
        }
    }
    componentWillUnmount() {
        BillingStore.removeChangeListener(this.refresh);
    }
    updateCreditCard() {
        if (this.state.loading) {
            const creditCard = BillingStore.getCreditCard();
            this.setState({
                cardNumber: `************${creditCard.last4}`,
                expiryMonth: CreditCardForm.getExpiryMonthFromInt(creditCard.exp_month),
                expiryYear: creditCard.exp_year,
                loading: false,
            });
        }
    }
    updateValidation() {
        this.setState({
            validations: BillingStore.getCreditCardValidation(),
        });
    }
    render() {
        const { t } = this.props;
        const formDetails = (React.createElement(CargomaticCard, { className: this.props.className, header: () => (React.createElement("div", { className: "flex items-center space-x-2 justify-between" },
                React.createElement("h3", { className: "my-0" }, t('CREDIT_CARD')),
                React.createElement("span", null,
                    t('STRIPE_CUSTOMER_ID'),
                    ": ",
                    getStripeCustomerId()))), footer: () => (React.createElement("div", { className: "actions" },
                React.createElement("button", { className: "button button-green", onClick: this.onSave }, titleize(t('SAVE'))))), grayFooter: true },
            React.createElement("div", { className: "mb-4 sm:grid sm:grid-cols-6 sm:gap-4" },
                React.createElement("div", { className: "sm:col-span-4" },
                    React.createElement(CargomaticInput, { label: t('CARD_NUMBER'), value: this.state.cardNumber, onChange: this.handleInputChange('cardNumber') }))),
            React.createElement("div", { className: "sm:grid sm:grid-cols-6 sm:gap-4" },
                React.createElement(CargomaticSelect, { name: "expiryMonth", label: t('EXPIRY_MONTH'), value: this.state.expiryMonth, onSelect: this.handleMonthChange, items: months, valueKey: "value", textKey: "name" }),
                React.createElement(CargomaticInput, { name: "expiryYear", type: "number", step: 1, min: 1900, label: t('EXPIRY_YEAR'), value: this.state.expiryYear, onChange: this.handleInputChange('expiryYear') }),
                React.createElement(CargomaticInput, { name: "cvv", type: "number", step: 1, label: t('CVV'), value: this.state.cvv, onChange: this.handleInputChange('cvv') }))));
        return (React.createElement("div", { className: this.props.className },
            !_.isEmpty(this.state.validations) && (React.createElement(Alert, { type: "error" },
                React.createElement("ul", null, _.values(this.state.validations).map((error) => (React.createElement("li", { key: error }, t(error))))))),
            this.state.loading ? React.createElement("div", null, t('LOADING')) : formDetails));
    }
}
export default withTranslation()(CreditCardForm);
